import React, {useContext, useCallback} from 'react'
import styled, {ThemeContext} from 'styled-components'
import { useHistory } from 'react-router-dom'
import { Text } from 'rebass'
import { ButtonConfirmed } from '../Button'
const Wrapper = styled.div`
  text-align: center;
  img{
    margin: 0 auto;
  }
`
const CreatedBtn = styled(ButtonConfirmed)`
  color: ${({theme}) => theme.white};
  font-family: 'Roboto-Bold';
  padding: 0;
  border: none;
  font-size: 14px;
  width: 172px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  margin: 0 auto;
  margin-top: 16px;
  align-self: flex-start;
  background: linear-gradient(305.04deg, #FFD600 -43.12%, #FF7A00 70.33%);
  border-radius: 35px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-self: center; 
  `}
`

export default function NoMyArtwork () {
  const history = useHistory()
  const theme = useContext(ThemeContext)
  const goExplore = useCallback(() => {
    history.goBack()
  }, [])
  return (
    <Wrapper>
      <img src="/images/collection/noNFT.png" alt=""/>
      <Text fontSize={16} color={theme.text7} fontFamily={'Roboto-Bold'}>You don't have any NFT</Text>
      <CreatedBtn onClick={goExplore}>Explore</CreatedBtn>
    </Wrapper>
  )
}